<template>
<div class="yx-guide-page div-scroll">
    <iframe src="https://stu.hbut.edu.cn/static/welcome/%E6%B9%96%E5%8C%97%E5%B7%A5%E4%B8%9A%E5%A4%A7%E5%AD%A62024%E7%BA%A7%E6%96%B0%E7%94%9F%E5%85%A5%E5%AD%A6%E9%A1%BB%E7%9F%A5.pdf" frameborder="0"></iframe>
</div>
</template>

<script>
export default {
    name:"",
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    }
}
</script>
